const SvgIcon = ({ size='24', color='#fff' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    version="1.1"
    viewBox="0 0 24 24"
  >
    <path
      fill={color}
      strokeWidth="0.5"
      d="M12 24q-2.5 0-4.683-.95a12.2 12.2 0 0 1-3.8-2.566 12.2 12.2 0 0 1-2.566-3.8Q0 14.502 0 12q0-2.501.95-4.683a12.3 12.3 0 0 1 2.566-3.8 12.1 12.1 0 0 1 3.8-2.566Q9.503.002 12 0q2.733 0 5.184 1.167a11.6 11.6 0 0 1 4.15 3.3V1.333H24v8h-8V6.667h3.667A9.9 9.9 0 0 0 16.3 3.733 9 9 0 0 0 12 2.667q-3.9 0-6.616 2.717T2.667 12q-.001 3.9 2.717 6.617 2.719 2.72 6.616 2.716 3.5 0 6.117-2.266t3.083-5.734h2.733q-.5 4.567-3.916 7.618Q16.601 24 12 24m3.733-6.4-5.066-5.067v-7.2h2.666v6.134l4.267 4.266Z"
    ></path>
  </svg>
);

export default SvgIcon;
